import React from 'react';
import { useModal } from 'react-modal-hook';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AlertContent, Button, ModalFactory } from 'components';
import { PaymentMethodForm } from 'forms';
import { routeConstants } from 'routes';
import { selectCurrentUserCard } from 'store/User';
import { AccountSetupFooter, AccountSetupHeader } from './components';

const AccountSetupPaymentMethod = () => {
  const hasPaymentMethod = !!useSelector(selectCurrentUserCard());

  // Routing
  const history = useHistory();
  const nextStep = routeConstants.private.accountSetup.complete;

  // Modal
  const [showModal, hideModal] = useModal(() => {
    const handleSkip = () => {
      hideModal();
      history.push(nextStep);
    };

    return (
      <ModalFactory customModal isActive onClose={hideModal}>
        <AlertContent
          title="Skip payment method?"
          message={<>You will not be able to receive payments until you set up a card. You can do this later.</>}
          leftActionLabel="Skip"
          onLeftAction={handleSkip}
          rightActionLabel="Set Up Now"
          onRightAction={hideModal}
        />
      </ModalFactory>
    );
  }, []);

  const handleSave = () => (hasPaymentMethod ? history.push(nextStep) : showModal());

  return (
    <>
      <AccountSetupHeader data-cy="account-setup-header" title="Set up your bank card for instant payments." message="Enter your card information below so that your employer can pay you directly." />

      <PaymentMethodForm accountSetup />

      <AccountSetupFooter>
        <Button appearance={hasPaymentMethod ? 'primary' : 'secondary'} label="Next" onClick={handleSave} size="large" data-cy="account-setup-payment-method-button" />
      </AccountSetupFooter>
    </>
  );
};

export default AccountSetupPaymentMethod;
